export default {
  interface: {
    funding: {
      round: '轮次',
      funding_amount: '融资金额',
      valuation: '估值',
      lead_investor: '领投',
    },
    image: '图片',
    show_more: '显示更多',
    max_20_chars: '最多20个字符',
    max_400_chars: '最多400个字符',
    ai_inspiration_hub: 'AI灵感库',
    weekly_pick: '每周精选',
    loading_data: '正在加载数据…',
    dateNav: {
      year: '年',
      month: '月',
      allTime: '全部时间',
      jump: '年月',
      collapse: '收起',
      day: '日',
      selectDay: '选择日期',
      allDays: '全部日',
      weekRange: '{sm}{sd}日 - {em}{ed}日',
      dayFormat: '{day}日',
    },
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    share: {
      card_button: '分享',
      title: '分享卡片',
      sharer: '分享人',
      sharerPlaceholder: '你的称呼，可留空',
      message: '分享语',
      messagePlaceholder: '你对这个产品的想法，可留空',
      generate: '生成卡片',
      generating: '生成中...',
      cancel: '取消'
    },
    nav: {
      home: 'AI产品',
      funding: 'AI融资',
    },
    pageTitle: {
      home: 'AI产品动态 - AI灵感库',
      tag: '{tag} 相关产品 - AI灵感库',
    },
    title: {
      home: 'AI产品',
      funding: 'AI融资动态',
      search: '搜索："{query}"',
      tag: '{tag} 相关产品',
      exportChannels: '产品发布渠道',
      tools: '实用工具'
    },
    search: {
      placeholder: '搜索 AI 产品...',
      button: '搜索',
      noResults: {
        title: '抱歉，没有找到相关结果',
        suggestion: '请尝试使用其他关键词搜索'
      }
    },
    product: {
      visit_website: '访问 {name} 官网',
      logo_alt: '{name} logo',
      preview_image: '{name} 产品展示图片 {index}/{total}',
      preview_image_full: '{name} 产品展示图片（大图） {index}/{total}',
      view_more_tag: '查看更多{tag}相关产品'
    }
  },
  channel: {
    scale: '规模'
  },
  meta: {
    description: 'AI灵感库为您提供最新、最全的AI产品和工具，寻找自己的产品灵感和工作流工具',
    tagDescription: '探索{tag}相关的AI产品和工具，发现创新解决方案',
    keywords: {
      home: 'AI灵感库, AI工具, AI产品, AI应用, AI资源, 人工智能工具, AI开发, 创意工具, 工作流, 创业, 独立开发',
      tag: '{tag}, AI工具, AI产品, AI应用，人工智能, 创新工具, 智能应用'
    }
  }
}
